module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/weronika-piwowarska-1b03fc1fbc695d050c7d65cc077b3cb9.webp";